<template>
  <div>
    <div class="table">
      <div class="table__title-wrapper">
        <div class="container">
          <div class="table__title-inner">
            <div class="table__title-item">N/S</div>
            <div class="table__title-item">Business Name</div>
            <div class="table__title-item">Address</div>
            <div class="table__title-item">Contact Name</div>
            <div class="table__title-item">Cell Phone</div>
          </div>
        </div>
      </div>

      <div class="table__main">
        <Customer
          v-for="customer in customers"
          :key="customer.id"
          :info="customer"
          @click.native="$router.push('/users/customers/' + customer.id)"
        />
      </div>
    </div>
    <infinite-loading v-if="!isLoading && hasMoreResults" @infinite="infLoad"></infinite-loading>
  </div>
</template>

<script>
import Customer from './Customer'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'PublicCustomers',
  components: {Customer, InfiniteLoading},
  data: () => ({
    isLoading: false
  }),
  computed: {
    customers() {
      return this.$store.getters['publicCustomers/customers']
    },
    hasMoreResults() {
      return this.customers.length < this.totalCount && this.page > 1
    },
    totalCount() {
      return this.$store.getters['publicCustomers/pagination'].total
    },
    page() {
      return this.$store.getters['publicCustomers/page']
    }
  },
  created() {
    if (!this.$store.getters['publicCustomers/customers'].length) {
      this.$store.dispatch('publicCustomers/fetch')
    }
  },
  methods: {
    async infLoad() {
      this.isLoading = true
      try {
        await this.$store.dispatch('publicCustomers/fetch')
        this.$emit('loaded')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
